import React, { useCallback } from 'react';
// import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
// import { Button } from 'ui-components/components/button';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { emptyArray } from 'ui-components/default-props/empty';

import { messages } from './messages';
import style from './style.module.less';
import {
  TODO_CHECKED,
  // TODO_ACTION_CLICKED
} from '../../../../constants/analytics-events';
import { Segment } from '../../../../services/analytics-services/segment';
import { useFTUWizardContext } from '../ftu-wizard/context/ftu-wizard-context';

/**
 * TodoCard component for displaying a card with a title, description, checkbox, and learn more link
 * @param {object} props - Component props
 * @param {object} props.title - Title message descriptor for FormattedMessage
 * @param {object} props.description - Description message descriptor for FormattedMessage
 * @param {string} props.id - Unique identifier for the card
 * @param {boolean} props.onlyFooter - Optional prop to render only the footer content
 * @returns {React.ReactElement} The TodoCard component
 */
export const TodoCard = ({ title, description, id, onlyFooter = false }) => {
  const { todosInLocalState = emptyArray, updateTodosWithSave } = useFTUWizardContext();
  const currentTodo = todosInLocalState.find((todo) => todo.id === id);
  const isChecked = currentTodo?.isVisible ?? false;

  // const onLearnMoreClick = useCallback(() => {
  //   // Track todo action click for analytics
  //   Segment.trackEvent(TODO_ACTION_CLICKED, {
  //     todoId: id,
  //   });

  // This is waiting on pendo integration
  //   return null;
  // }, [id]);

  const toggleCheckbox = useCallback(() => {
    const newCheckedState = !isChecked;

    // Track todo checkbox toggle for analytics
    Segment.trackEvent(TODO_CHECKED, {
      isChecked: newCheckedState,
      todoId: id,
    });

    let updatedTodos;
    if (currentTodo) {
      updatedTodos = todosInLocalState.map((todo) => {
        if (todo.id === id) {
          return {
            ...todo,
            isVisible: newCheckedState,
            isCompleted: newCheckedState ? todo.isCompleted : false,
          };
        }
        return todo;
      });
    } else {
      updatedTodos = [...todosInLocalState, { id, isVisible: newCheckedState, isCompleted: false }];
    }

    updateTodosWithSave(updatedTodos);
  }, [isChecked, id, currentTodo, updateTodosWithSave, todosInLocalState]);

  return (
    <FlexColumn className={!onlyFooter && style['todo-card']}>
      {!onlyFooter && (
        <>
          <div className={style['card-content']}>
            <Text className={style['card-title']} textType={TextType.Label} value={title} />
            <Text className={style['card-description']} textType={TextType.Paragraph} value={description} />
          </div>
        </>
      )}
      <div className={style.separator} />
      <FlexRow className={style['card-footer']}>
        <div className={style.checkbox}>
          <Checkbox checked={isChecked} id={`todo-checkbox-${id}`} name={`todo-checkbox-${id}`} onChange={toggleCheckbox} />
          <Text textType={TextType.Paragraph} value={messages.addToDoLater} />
        </div>
        {/* This will open up pendos that are not ready. This will be uncommented when Pendo integration is ready */}
        {/* <Button className={style['learn-more-link']} onClick={onLearnMoreClick} theme='link'> */}
        {/*   <FormattedMessage {...messages.learnMore} /> */}
        {/* </Button> */}
      </FlexRow>
    </FlexColumn>
  );
};
